export const FETCH_TRANSLATIONS = 'fetchTranslations'
export const FETCH_SOURCE_WORDS = 'fetchSourceWords'
export const REFRESH_SOURCE_WORDS = 'refreshSourceWords'
export const FETCH_CATEGORIES = 'fetchCategories'
export const FETCH_SECTIONS = 'fetchSections'
export const FETCH_TRANSLATED_CATEGORIES = 'fetchTranslatedCategories'
export const FETCH_TRANSLATED_SECTIONS = 'fetchTranslatedSections'
export const FETCH_LANGUAGES = 'fetchLanguages'
export const FETCH_ALPHABET = 'fetchAlphabet'
export const FETCH_TRANSLITERATED_ALPHABET = 'fetchTransliteratedAlphabet'
export const CHANGE_DICTIONARY = 'changeDictionary'
export const CHANGE_SOURCE_DICTIONARY = 'changeSourceDictionary'
export const FETCH_SOURCE_DICTIONARIES = 'fetchSourceDictionaries'
export const SOURCE_DICTIONARY_CREATE = 'createSourceDictionary'
export const SOURCE_DICTIONARY_UPDATE = 'updateSourceDictionary'
export const TRANSLATION_DICTIONARY_CREATE = 'createTranslationDictionary'
export const LOAD_COMMON_DATA = 'loadCommonData'
export const MOVE_WORD = 'moveWord'
export const MOVE_LETTER = 'moveLetter'
export const NEXT_TRANSLATION = 'nextTranslation'
